import { render, staticRenderFns } from "./Set.vue?vue&type=template&id=2cc763ae&scoped=true"
import script from "./Set.vue?vue&type=script&lang=js"
export * from "./Set.vue?vue&type=script&lang=js"
import style0 from "./Set.vue?vue&type=style&index=0&id=2cc763ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc763ae",
  null
  
)

export default component.exports